module.exports = __webpack_public_path__ + "static/media/delivery.ecdd75d4.svg";